import React, { Component } from "react";
import { Row, Col, Space, Image } from "antd";
import { Link } from "react-router-dom";
import "../App.css";

export default class GameArt extends Component {
  render() {
    return (
      <>
        <Row>
          <Col xs={1} sm={2} md={1} lg={2} xl={1}></Col>
          <Col xs={22} sm={20} md={22} lg={20} xl={22}>
            <Row>
              <Col span={24} className="projectTitle">
                Game Art Projects
              </Col>
              <Col span={24} className="projectSubTitle">
                Design and Assets Painting
              </Col>
              <Col span={24} className="rH50"></Col>
            </Row>
            <Row gutter={[8, 8]}>
              <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                <Space
                  direction="vertical"
                  size="small"
                  style={{ width: "100%" }}
                >
                  <Link to="/Ciga">
                    <Image
                      src={`${process.env.PUBLIC_URL}/images/jpg/CigaCover.jpg`}
                      loading="lazy"
                      className="img100"
                      alt="Ciga Game Jame 2024 Image"
                      preview={{
                        visible: false,
                        mask: <div></div>,
                      }}
                    />
                  </Link>
                  <div className="paddTop10 f1-5EM color00">
                    Ciga Game Jam 2024
                  </div>
                  <div className="paddTop10 f2EM color110 fAN">
                    Endless Reminiscence
                  </div>
                  <div className="paddTop20"></div>
                </Space>
              </Col>
              <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                <Space
                  direction="vertical"
                  size="small"
                  style={{ width: "100%" }}
                >
                  <Link to="/Global">
                    <Image
                      src={`${process.env.PUBLIC_URL}/images/jpg/GlobalCover.jpg`}
                      loading="lazy"
                      className="img100"
                      alt="Ciga Game Jame 2024 Image"
                      preview={{
                        visible: false,
                        mask: <div></div>,
                      }}
                    />
                  </Link>
                  <div className="paddTop10 f1-5EM color00">
                    Global Game Jam 2025
                  </div>
                  <div className="paddTop10 f2EM color110 fAN">Popped Time</div>
                  <div className="paddTop20"></div>
                </Space>
              </Col>
              <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                <Space
                  direction="vertical"
                  size="small"
                  style={{ width: "100%" }}
                >
                  <Link to="/Indie">
                    <Image
                      src={`${process.env.PUBLIC_URL}/images/jpg/IndieCover.jpg`}
                      loading="lazy"
                      className="img100"
                      alt="Ciga Game Jame 2024 Image"
                      preview={{
                        visible: false,
                        mask: <div></div>,
                      }}
                    />
                  </Link>
                  <div className="paddTop10 f1-5EM color00">
                    Indie Game Project
                  </div>
                  <div className="paddTop10 f2EM color110 fAN">
                    Alex's Painter Dream
                  </div>
                  <div className="paddTop20"></div>
                </Space>
              </Col>
            </Row>
          </Col>
          <Col xs={1} sm={2} md={1} lg={2} xl={1}></Col>
        </Row>
        <Row>
          <Col className="rH100"></Col>
        </Row>
        <Row>
          <Col className="rH100"></Col>
        </Row>
      </>
    );
  }
}
